<template>
  <div>
    <v-card
      flat
      class="rounded-lg mt-5 textLight--text"
      @click="navigateToEmployeeProfilePage"
    >
      <v-row class="pa-2" align="center">
        <v-col cols="12" sm="6" md class="ps-6">
          <div class="font-weight-light">
            <div class="d-flex flex-row justify-start flex-md-row align-center">
              <!-- <v-img
                class="rounded-lg ps-3"
                max-height="40"
                max-width="40"
                :src="
                  employeeData && employeeData.user && employeeData.user.avatar
                    ? getImage(employeeData.user.avatar)
                    : null
                "
                lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
                contain
              /> -->

              <div class="align-center" style="text-align: start">
                <div class="text--left subtitle-1 text-ellipse-4">
                  <span>
                    {{
                      employeeData && employeeData.user
                        ? `${employeeData.user.firstName || ""} ${
                            employeeData.user.lastName || ""
                          }`
                        : "-"
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md class="ps-6 ps-sm-3 text-start">
          <span class="text-ellipse-4">
            {{
              employeeData.organization && employeeData.organization._id
                ? findOrganization(employeeData.organization._id)
                : "-"
            }}
          </span>
        </v-col>

        <v-col cols="12" sm="6" md class="ps-6 ps-md-3">
          <span class="text-start text-ellipse-4">
            {{
              employeeData.user && employeeData.user.email
                ? employeeData.user.email
                : "-"
            }}
          </span>
        </v-col>

        <v-col cols="12" sm="6" md class="ps-6 ps-sm-3">
          <span class="text-start text-ellipse-4">
            {{
              employeeData.user && employeeData.user.civilIdOrPassport
                ? employeeData.user.civilIdOrPassport
                : "-"
            }}
          </span>
        </v-col>

        <v-col cols="12" md="3" class="px-6 px-md-3 text-start">
          <div
            v-if="
              employeeData.user &&
              employeeData.user.subRoles &&
              employeeData.user.subRoles.length
            "
          >
            <div
              style="
                background: rgba(230, 230, 230, 0.5);
                overflow-y: auto;
                overflow-x: hidden;
                height: 125px;
              "
              class="px-5 py-2 rounded-lg"
            >
              <span
                v-for="(role, index) in findSubRoles(
                  employeeData.user.subRoles
                )"
                :key="index"
                class="text-truncate"
              >
                <v-chip color="#28116280" class="me-1 mt-1 rounded-lg">
                  <span class="text-truncate textLight--text"> {{ role }}</span>
                </v-chip>
              </span>
            </div>
          </div>

          <div v-else>{{ $t("user.employees.noRolesAssigned") }}</div>
        </v-col>

        <v-col cols="12" md="auto">
          <v-row :style="$vuetify.breakpoint.mdAndUp ? { width: '70px' } : ''">
            <template v-if="havePermissionUpdateEmployee">
              <v-col cols="4" md="12" v-on:click.stop>
                <v-btn
                  height="27"
                  width="27"
                  icon
                  color="primary"
                  @click="$emit('editEmployee', employeeData)"
                >
                  <div class="d-flex flex-column">
                    <v-icon size="20" style="height: 10px">
                      mdi-pencil-outline
                    </v-icon>

                    <v-icon size="20" style="height: 5px">mdi-minus</v-icon>
                  </div>
                </v-btn>
              </v-col>
            </template>

            <template
              v-if="
                havePermissionUpdateEmployee ||
                havePermissionEnableDisableEmployee
              "
            >
              <v-col cols="4" md="12" v-on:click.stop>
                <div class="d-flex justify-center">
                  <v-switch
                    flat
                    dense
                    hide-details
                    inset
                    color="success"
                    v-model="employeeData.user.isActive"
                    :loading="statusUpdateLoading"
                    @change="
                      value => updateOrDelete(value ? 'enable' : 'disable')
                    "
                    class="ma-0"
                  >
                  </v-switch>
                </div>
              </v-col>
            </template>

            <template v-if="havePermissionDeleteEmployee">
              <v-col cols="4" md="12" v-on:click.stop>
                <v-icon
                  @click="updateOrDelete('delete')"
                  size="20"
                  color="error"
                >
                  mdi-trash-can-outline
                </v-icon>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { updateEmployee } from "../methods/updateEmployee";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  props: {
    employeeData: {
      type: Object,
      required: true,
    },
    organizationsArr: {
      type: Array,
    },
    subRolesArr: {
      type: Array,
    },
  },
  data() {
    return {
      isOpen: false,
      rolesSelected: [],
      roleUpdateLoading: false,
      statusUpdateLoading: false,
    };
  },
  computed: {
    havePermissionUpdateEmployee() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["UPDATE_EMPLOYEE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionEnableDisableEmployee() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["ENABLE_DISABLE_EMPLOYEE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionDeleteEmployee() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_EMPLOYEE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    navigateToEmployeeProfilePage() {
      this.$router.push({
        name: "EmployeeProfile",
        params: { userId: this.employeeData?.user?._id },
      });
    },
    findOrganization(id) {
      let val = this.organizationsArr.find(obj => id === obj._id);
      if (val) {
        return this.getLocalisedValue(val.name);
      }
    },
    findSubRoles(existingSubRolesArr) {
      let newArr = this.subRolesArr.filter(role => {
        return existingSubRolesArr.find(existingRole => {
          return role._id === existingRole._id;
        });
      });
      if (newArr.length) {
        return newArr.map(obj => {
          return obj.name;
        });
      }
    },

    async updateOrDelete(val) {
      if (val) {
        this.statusUpdateLoading = true;
        if (val === "enable") {
          let updateData = {
            user: {
              isActive: true,
            },
          };
          let response = await this.update(this.employeeData._id, updateData);
          if (response) {
            this.statusUpdateLoading = false;
            if (response.error) {
              this.employeeData.user.isActive = false;
              this.$emit("updateErr");
            }
          }
        } else if (val === "disable") {
          let updateData = {
            user: {
              isActive: false,
            },
          };
          let response = await this.update(this.employeeData._id, updateData);
          if (response) {
            this.statusUpdateLoading = false;
            if (response.error) {
              this.employeeData.user.isActive = true;
              this.$emit("updateErr");
            }
          }
        } else if (val === "delete") {
          this.$emit("deleteEmployee", this.employeeData._id);
          this.statusUpdateLoading = false;
        }
      }
    },
    update(id, data) {
      return updateEmployee({
        id: id,
        input: data,
      });
    },
  },
};
</script>
